import { $el } from 'src/scripts/utils/utils'
import { BaseComponent } from '../base-component'
import { isEnterKey } from 'src/scripts/utils/key'

const BUTTON_SELECTOR = '[data-back-to-top-button]'

export class BackToTopButton extends BaseComponent {
  mountComponent(): void {
    this.addListener(this, 'keydown', this.handleKeydown)
    this.addListener(this, 'click', this.handleButtonClick)
    this.addListener(window, 'scroll', this.handleWindowScroll)
  }

  handleWindowScroll = (): void => {
    const button = $el(BUTTON_SELECTOR, this)
    button?.classList.toggle('is-visible', window.scrollY > window.innerHeight)
  }

  handleButtonClick = (): void => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  handleKeydown = (event: KeyboardEvent): void => {
    if (isEnterKey(event)) {
      const skipContent = $el('#SkipContent')
      window.scrollTo({ top: 0, behavior: 'instant' })
      skipContent.focus()
    }
  }
}
